import React from "react";
import { CurrencyRupeeIcon } from "@heroicons/react/outline";
import NumberInput from "../../../../common/NumberInput";

const MetalMarginCard = ({
  metal,
  sellMargin,
  buyMargin,
  onSellMarginChange,
  onBuyMarginChange,
  disabled
}) => {
  const getStepValue = () => metal.id === 'silver' ? "1" : "10";
  const getPlaceholder = () => ({
    gold: { sell: "250", buy: "-150" },
    silver: { sell: "5", buy: "-3" },
    platinum: { sell: "300", buy: "-200" }
  }[metal.id]);

  return (
    <div className={`${metal.bgColor} p-4 rounded-lg mb-4`}>
      <h4 className="font-medium mb-3 flex items-center">
        <CurrencyRupeeIcon className={`h-5 w-5 mr-2 text-${metal.color}-600`} />
        {metal.name} Margins
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Selling Margin (₹/gm)
          </label>
          <NumberInput
            value={sellMargin}
            onChange={onSellMarginChange}
            prefix="₹"
            step={getStepValue()}
            placeholder={getPlaceholder().sell}
            disabled={disabled}
          />
          <p className="text-xs text-gray-500 mt-1">
            Added to base rate when selling
          </p>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Buying Margin (₹/gm)
          </label>
          <NumberInput
            value={buyMargin}
            onChange={onBuyMarginChange}
            prefix="₹"
            step={getStepValue()}
            placeholder={getPlaceholder().buy}
            disabled={disabled}
          />
          <p className="text-xs text-gray-500 mt-1">
            Deducted from base rate when buying
          </p>
        </div>
      </div>
    </div>
  );
};

export default MetalMarginCard;
